module.exports = __webpack_public_path__ + "img/xbsys1.7609c28b.png";